import { Tooltip } from 'antd';
import React from 'react';
import DokanIcons from '../icon/DokanIcons';
/**
 */
const DokanExportImportButton = () => (
    <div className="flex">
        <Tooltip placement="top" title="Export All">
            <div className="exp-imp-btn rounded-l-md">
                <DokanIcons icon="#export" size={4} />
            </div>
        </Tooltip>

        <Tooltip placement="top" title="Import">
            <div className="exp-imp-btn rounded-r-md">
                <DokanIcons icon="#import" size={4} />
            </div>{' '}
        </Tooltip>
    </div>
);

export default DokanExportImportButton;
